export function BackgroundLoading() {
	return (
		<>
			<div className="wp-line-content wp-line-height-50 wp-line-width-50">
				<div className="backgroud-loading-bar"></div>
			</div>
			<br />
			<div className="wp-line-content wp-line-height-50">
				<div className="backgroud-loading-bar"></div>
			</div>
			<br />
			<div className="wp-line-content">
				<div className="backgroud-loading-bar"></div>
			</div>
			<div className="wp-line-content wp-line-height-50">
				<div className="backgroud-loading-bar"></div>
			</div>
			<div className="wp-line-content">
				<div className="backgroud-loading-bar"></div>
			</div>
			<div className="wp-line-content">
				<div className="backgroud-loading-bar"></div>
			</div>
			<div className="wp-line-content">
				<div className="backgroud-loading-bar wp-line-height-50"></div>
			</div>
		</>
	);
}
